import { Component } from "react";
import type { ReactNode } from "react";

/** Catches render/lazy-load errors in a subtree (e.g. the map chunk) and shows a fallback. */
export class ErrorBoundary extends Component<
  { fallback: ReactNode; children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  render() {
    return this.state.failed ? this.props.fallback : this.props.children;
  }
}
